<script setup lang="ts">
export type WhatsappLinkColor = 'green' | 'white';
// PROPS
defineProps({
    color: { type: String as PropType<WhatsappLinkColor>, default: 'white' },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const route = useRoute();
const config = useRuntimeConfig();

// DATA
const whatsappLink = computed(
    () => `https://wa.me/393281795984?text=${encodeURIComponent(tt('whatsapp', { url: `${config.public.frontendBaseUrl}${route.fullPath}` }))}`
);
</script>

<template>
    <a :href="whatsappLink" target="_blank">
        <SvgoWhatsappGreen v-if="color === 'green'" class="h-[36px] w-[160px]" :font-controlled="false" filled />
        <SvgoWhatsapp v-else class="h-[36px] w-[160px]" :font-controlled="false" filled />
    </a>
</template>
